module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_BG-fb3f6a6b208ed6fb81ecf99af194a874.svg";